module.exports = __webpack_public_path__ + "static/media/loader.415a6862.svg";